/* eslint-disable */
import $ from 'jquery';

export default {
    init() {
        $(document).ready(function(){
            $('.wrap').css('padding','0');
        })
    },
    finalize() {

        
        $(document).ready(function(){
            var count = 0;
            var maxCount = 0;

            $.ajax({
                data: {
                    action: 'maxCount',
                    id: sessionStorage.getItem('id')
                },
                method : 'POST',
                url : ajaxObject.ajaxurl,
                success: function(response){
                    maxCount = parseInt(response);
                }
            })
            $(document).ajaxComplete(function(){
                $('#count').val(maxCount);
                $('.total').text(maxCount+1);
            })
            
            retrieve_tips_from_session(1, 1, 'load', count)
            navigation(count)   
            var score = sessionStorage.getItem('score')
            if(score > 20){
                $('h1').html('Watch out, your leak risk is <span class="text-orange">very high!</span>')
            } else if(score > 15 && score <= 20){
                $('h1').html('Your leak risk is <span class="text-orange-high">high!</span>')
            } else {
                $('h1').html('Your leak risk is <span class="text-orange-average">medium!</span>')
            }
            
        })

        $('form').submit(function(e){
            e.preventDefault();
            $.ajax({
                data: {
                    action: 'saveContact',
                    email: $(this).find('#email').val(),
                    id: sessionStorage.getItem('id'),
                    score: sessionStorage.getItem('score')
                },
                method : 'POST',
                url : ajaxObject.ajaxurl,
                success: function(response){
                    $('.success').removeClass('hidden')
                    $('form').slideUp()    
                    $('#title_form').text('You have just received an email!')

                }
            })
        })

        function navigation(count){
            $(document).on('click', '.next-step, .previous-step', function(e){
                var stepToDisplay = $(this).attr('data-stepToDisplay');
                var currentStep = $(this).attr('data-currentStep');
                var action = $(e.target).attr('id')
                
                if(action=='previous'){
                    count = count-1;
                } else {
                    count = count+1;
                }
                
                retrieve_tips_from_session(stepToDisplay, currentStep, 'clicked', count)
                
            })
        }

        function retrieve_tips_from_session(stepToDisplay, currentStep, status, count){
            var steps = [1, 2];
            if(sessionStorage.getItem(stepToDisplay)){
                $.ajax({
                    data: {
                        action: 'retrieve_tips_from_session',
                        step: stepToDisplay,
                        answers: sessionStorage.getItem(stepToDisplay),
                        id: sessionStorage.getItem('id')
                    },
                    method : 'POST',
                    url : ajaxObject.ajaxurl,
                    success: function(response){
                        var content = JSON.parse(response);
                        $('#illustration').attr('src', content[0]);
                        $('#title').text(content[1]);
                        $('#content').html(content[2]);
                        $('#risk').html(content[3]);

                        var prev = count-1;
                        var next = count+1;
                        if(count==0){
                            $('.previous-step').css('opacity',0)
                            $('.cache').addClass('hidden')
                            $('.next-step').show()
                            $('.next-step').attr('data-steptodisplay', steps[next])
                            $('.current').text(1);
                        } else if(count == 1){
                            $('.next-step').hide()
                            $('.previous-step').attr('data-steptodisplay', steps[prev])
                            $('.previous-step').css('opacity',1)
                            $('.cache').removeClass('hidden')
                            $('.current').text(2);
                        }                      
                    }
                })
            }
        }
          
        
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/self-audit-results.js